import { render, staticRenderFns } from "./ReceiptModal.vue?vue&type=template&id=73ab74cc&"
import script from "./ReceiptModal.vue?vue&type=script&lang=js&"
export * from "./ReceiptModal.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports